import { Dropdown, LearnMoreLink, Text } from '@ui/themed';

export function SelectField<T extends string>({
  label,
  description,
  value,
  options,
  onChange,
  learnMoreUrl,
}: {
  label: string;
  description?: string;
  value: T;
  options: { value: T; label: string }[];
  onChange: (value: T) => void;
  learnMoreUrl?: string;
}) {
  return (
    <div className="flex items-start justify-between gap-4">
      <div className="flex min-w-0 flex-1 flex-col">
        <Text>{label}</Text>
        {(description || learnMoreUrl) && (
          <Text size="sm" variant="secondary">
            {description}
            {learnMoreUrl && (
              <>
                {' '}
                <LearnMoreLink link={learnMoreUrl} />
              </>
            )}
          </Text>
        )}
      </div>
      <div className="w-48 shrink-0">
        <Dropdown options={options} value={value} onChange={(next) => onChange(next as T)} />
      </div>
    </div>
  );
}
